import { put, call, takeEvery, select, all, debounce } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { SEARCH } from 'constants/FilterConstants';
import { DEBOUNCE_TIME } from 'constants/Global';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { simpleRequestsLoader } from 'modules/app/utils';
import * as actions from 'modules/followUp/actions/core.actions';
import * as types from 'modules/followUp/actionTypes';
import { FOLLOW_DASHBOARD_SOURCE } from 'modules/followUp/constant';
import { getDashboardRequestParams } from 'modules/followUp/selectors/dashboard';

const requestsConfig = {
  [types.SEND_FOLLOW_UP]: {
    notifications: {
      success: { id: 'page.followup.confirm.send.success', defaultMessage: 'The follow-up has been send with success.' },
      failure: { id: 'page.followup.confirm.send.failure', defaultMessage: 'An error occurred during the follow-up send.' },
    }
  },
  [types.SCHEDULE_FOLLOW_UP]: {
    notifications: {
      success: { id: 'page.followup.confirm.schedule.success', defaultMessage: 'The follow-up has been scheduled with success.' },
      failure: { id: 'page.followup.confirm.schedule.failure', defaultMessage: 'An error occurred during the follow-up scheduling.' },
    }
  },
  [types.UNSCHEDULE_FOLLOW_UP]: {
    notifications: {
      success: { id: 'page.followup.confirm.unschedule.success', defaultMessage: 'The follow-up has been unscheduled with success.' },
      failure: { id: 'page.followup.confirm.unschedule.failure', defaultMessage: 'An error occurred during the follow-up unscheduling.' },
    }
  },
};

const REFRESH_ACTIONS = [
  SELECT_DEALER,
  types.SET_FOLLOW_UP_DASHBOARD_FILTERS,
  types.CLEAR_FOLLOW_UP_DASHBOARD_FILTER,
  types.REMOVE_FOLLOW_UP_DASHBOARD_FILTER,
  ({ type, payload }) => type === types.SET_FOLLOW_UP_DASHBOARD_FILTER && payload.field !== SEARCH
];

const DELAYED_REFRESH_ACTIONS = [
  ({ type, payload }) => type === types.SET_FOLLOW_UP_DASHBOARD_FILTER && payload.field === SEARCH
];

function* refreshDashboard() {
  const params = yield select(getDashboardRequestParams);

  if (!params.dealerId) {
    return;
  }

  yield put(actions.fetchFollowUps({ ...params, page: 0 }, { source: FOLLOW_DASHBOARD_SOURCE }));
}

function* onPageWorker() {
  yield call(refreshDashboard);

  yield takeEvery(REFRESH_ACTIONS, refreshDashboard);
  yield debounce(DEBOUNCE_TIME, DELAYED_REFRESH_ACTIONS, refreshDashboard);
}

export default function* FollowUpDashboardSagas() {
  yield scopeToPage([PATH.FOLLOW_UP], onPageWorker);
  yield all(simpleRequestsLoader(requestsConfig));
}
